import { Avatar, Box, Stack, Typography } from '@mui/material'
import Button from '@mui/material/Button';
import React from 'react';
import my from '../Home/my.jpg';
import Home1 from './Home1';
import '../About/About.css';
import {motion} from 'framer-motion';

const home = ()=>{
  return (
    
    <Stack id='home' direction="row" spacing= "2" sx={{justifyContent:'center',pt:35,pr:11,pb:15,
      '@media (min-width:150px) and (max-width:600px)': {
         display:'grid',
         justifyContent:'center',
         alignItems:'center',
         pl:'7rem',
         pt:18
       },}}>
       <motion.div
        whileInView={{opacity:1,x:0}}
        initial={{opacity:0,x:-100}} 
        transition={{duration:2.5}}
        className="w-full lg:w-1/2 lg:p-8">
      <Avatar
        alt='Sriram Radhey'
        src={my}
        sx={{ width: 230, height: 230, justifyContent: "center",objectFit:'fit',
          border:'3px solid cyan',
          '&:hover':{
            border:'5px solid green',
          }
        }}
      />
    </motion.div>
      <Box sx={{pl:7,pt:7,display:'grid'
      }}>
        <Typography variant='h1' sx={{color:'white',fontSize:25,pb:2}} className="no-select">Hi There 😀</Typography>
        <Typography variant="h2" sx={{color:'#f15e25',fontSize: 42,pb:2,
        '@media (min-width:150px) and (max-width:600px)':{
          fontSize:'20px',
        }
        }} className="no-select">
        I'M <span>N.Sriram Radhey</span>
      </Typography>
      <Box className="type-writer" sx={{color:'cyan',fontSize:28,
        '@media (min-width:150px) and (max-width:600px)':{
          fontSize:'20px'
        }}}>
        <Home1 /><br/>
        <Button href='https://drive.google.com/file/d/1g-wLfed4gJhpnNCeu50GuKl9pu50aH_R/view?usp=sharing' target='_blank' variant="contained" color="success" size="medium" sx={{mt:2,alignItems:'center',justifyContent:'center',
        '&:hover':{
          borderRadius:'50%',
          textDecoration:'none',
          backgroundColor:'purple',
          color:'white',
        }
      }}>Download CV</Button>
      </Box>
      </Box>
    </Stack>
   
  )
}

export default home